import { createTheme } from '@mui/material/styles'
import colors from './Colors'

const getPalette = (mode) => ({
  mode,
  content: {
    main: mode === 'light' ? '#fff' : '#303030',
    contrastText: mode === 'light' ? '#000' : '#fff',
  },
  primary: {
    main: mode === 'light' ? colors.primary : colors.primaryLight3,
  },
  primaryLight: {
    main: mode === 'light' ? colors.primaryLight : colors.primaryLight,
  },
  highlight: {
    main: mode === 'light' ? colors.highlightLight : colors.highlightDark,
  },
  secondary: {
    main: colors.secondary,
    contrastText: '#fff',
  },
  accent: {
    main: colors.accent,
    contrastText: '#fff',
  },
  info: {
    main: colors.info,
    dark: colors.infoDark,
    contrastText: '#fff',
  },
  successLight: {
    main: colors.successLight,
    dark: colors.successDark,
    contrastText: '#fff',
    type: 'rgb',
  },
  errorLight: {
    main: colors.errorLight,
    contrastText: '#fff',
    type: 'rgb',
  },
  warningLight: {
    main: colors.warningLight,
    contrastText: '#fff',
    type: 'rgb',
  },
  grayLight: {
    main: colors.grayLight,
    contrastText: '#000',
    type: 'rgb',
  },
  grayMedium: {
    main: colors.grayMedium,
    contrastText: '#000',
    type: 'rgb',
  },
  grayDark: {
    main: colors.grayDark,
    contrastText: '#000',
    type: 'rgb',
  },
  contrastSuperLight: {
    main: mode === 'light' ? '#f7f7f7' : '#202020',
    contrastText: mode === 'light' ? '#000' : '#fff',
    type: 'rgb',
  },
  contrastLight: {
    main: mode === 'light' ? '#f3f3f3' : '#404040',
    contrastText: mode === 'light' ? '#000' : '#fff',
    type: 'rgb',
  },
  contrastMedium: {
    main: mode === 'light' ? '#e0e0e0' : '#525252',
    contrastText: mode === 'light' ? '#000' : '#fff',
    type: 'rgb',
  },
  contrastHigh: {
    main: mode === 'light' ? '#aaa' : '#bbb',
    contrastText: mode === 'light' ? '#000' : '#fff',
    type: 'rgb',
  },
  white: {
    main: '#fff',
    contrastText: '#000',
  },
  label: {
    main: mode === 'light' ? 'rgba(0, 0, 0, 0.6)' : 'rgba(255, 255, 255, 0.7)',
  },
  menu: {
    main: mode === 'light' ? colors.primary : '#221212',
    accent: mode === 'light' ? colors.primaryLight3 : colors.primaryLight3,
    secondary: mode === 'light' ? colors.grayMedium : '#bbb',
    hasActive: mode === 'light' ? colors.primaryLight2 : '#332222',
    active: mode === 'light' ? colors.primaryLight3 : '#443333',
    selected: mode === 'light' ? '#fff' : '#aaa',
    contrastText: mode === 'light' ? '#fff' : '#fff',
  },
  navbar: {
    main: mode === 'light' ? '#f3f3f3' : '#202020',
    contrastText: mode === 'light' ? '#000' : '#fff',
    shadow: mode === 'light' ? '#666' : '#000',
  },
  changelistToolbar: {
    main: mode === 'light' ? '#f7f7f7' : '#202020',
    contrastText: mode === 'light' ? '#000' : '#fff',
  },
  sidebar: {
    main: mode === 'light' ? '#f3f3f3' : '#202020',
    contrastText: mode === 'light' ? '#000' : '#fff',
    shadow: mode === 'light' ? '#666' : '#000',
  },
  aside: {
    main: mode === 'light' ? '#464646' : '#353535',
    accent: mode === 'light' ? colors.primaryLight3 : colors.primaryLight3,
    secondary: mode === 'light' ? colors.grayMedium : '#ccc',
    hasActive: mode === 'light' ? '#575757' : '#464646',
    active: mode === 'light' ? '#5d5d5d' : '#565656',
    selected: mode === 'light' ? '#fff' : '#aaa',
    contrastText: mode === 'light' ? '#fff' : '#fff',
  },
  trHover: {
    main: mode === 'light' ? '#ebebeb' : '#202020',
    contrastText: mode === 'light' ? '#000' : '#fff',
  },
  dashbaordStatAll: {
    main: mode === 'light' ? colors.dashboardStatAll : colors.dashboardStatAll,
    dark:
      mode === 'light'
        ? colors.dashboardStatAllDark
        : colors.dashboardStatAllDark,
    contrastText: mode === 'light' ? '#fff' : '#fff',
  },
  dashbaordStatWorking: {
    main:
      mode === 'light'
        ? colors.dashboardStatWorking
        : colors.dashboardStatWorking,
    dark:
      mode === 'light'
        ? colors.dashboardStatWorkingDark
        : colors.dashboardStatWorkingDark,
    contrastText: mode === 'light' ? '#fff' : '#fff',
  },
  dashbaordStatNotWorking: {
    main:
      mode === 'light'
        ? colors.dashboardStatNotWorking
        : colors.dashboardStatNotWorking,
    dark:
      mode === 'light'
        ? colors.dashboardStatNotWorkingDark
        : colors.dashboardStatNotWorkingDark,
    contrastText: mode === 'light' ? '#fff' : '#fff',
  },
  dashbaordStatNotActive: {
    main:
      mode === 'light'
        ? colors.dashboardStatNotActive
        : colors.dashboardStatNotActive,
    dark:
      mode === 'light'
        ? colors.dashboardStatNotActiveDark
        : colors.dashboardStatNotActiveDark,
    contrastText: mode === 'light' ? '#fff' : '#fff',
  },
  chart: {
    main: mode === 'light' ? '#fff' : '#202020',
    contrastText: mode === 'light' ? '#000' : '#fff',
  },
  resizableBorder: {
    main: mode === 'light' ? 'rgba(0, 0, 0, .1)' : 'rgba(0, 0, 0, .4)',
  },
  gradientScaleBorder: {
    main: mode === 'light' ? '#000' : '#303030',
  }
})

function container() {
  // Use the fullscreen element if in fullscreen mode, otherwise just the document's body
  return document.fullscreenElement ?? document.body;
}

const getTheme = (mode) => {
  const theme = createTheme({
    palette: getPalette(mode),
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontSize: 14,
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
    },
    overrides: {
      MuiTableCell: {
        sizeSmall: {
          padding: '4px 8px',
        },
      },
    },
    components: {
      MuiMenu: {
        defaultProps: {
          container,
        },
      },
      MuiTooltip: {
        defaultProps: {
          PopperProps: {
            container,
          },
        },
      },
    },
  })
  return theme
}

export default getTheme
